import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  public registerSvgIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'writing',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/writing.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'person_edit',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/edit_user.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'customer',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/customer.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'box',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/box.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'car',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/car.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'driving',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/driving.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'signposts',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/signposts.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'maps-and-flags',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/maps-and-flags.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'worldwide',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/worldwide.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cogwheels',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/cogwheels.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'users',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/users.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'page-not-found',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/page-not-found.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'musical-note',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/musical-note.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'audio-waves',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/audio-waves.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'church',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/church.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'quiz-title',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/quiz-title.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'office',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/office.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'department',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/department.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'address-book',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/address-book.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'career',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/career.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'hands-praying-solid',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/hands-praying-solid.svg')
    );
  }
}
